import { createStyles, TextField, Theme, WithStyles, withStyles } from '@material-ui/core'
import React from 'react'

interface OutcomeTextItemProps extends WithStyles<typeof styles> {
	label?: string
	prop: string
	value: any
	placeholder: string
	onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	required?: boolean
	maxLength?: number
	otherProps?: { [key: string]: any }
}

const OutcomeTextItem: React.FC<OutcomeTextItemProps> = (props: OutcomeTextItemProps) => {
	const { classes, onInputChange, label, maxLength, otherProps, placeholder, prop, required, value } = props

	return (
		// <div className={classes.root} style={{'margin': '-4px', 'width': 'calc(100% + 8px)'}}>
		<div className={classes.root}>
			{label && <div className={classes.label} style={{'padding': '4px', maxWidth: '25%'}}>{label}&#58; { props.required === true && (<span className={classes.requiredField} >*</span> ) }</div> }

			<div className={classes.textWrapper}>
				<TextField
					name={prop}
					value={value}
					autoFocus={true}
					fullWidth={true}
					className={classes.textField}
					placeholder={ (required)?`${placeholder}*`:placeholder}
					margin="dense"
					variant="outlined"
					InputProps={{
						inputProps: {
							title: `Please Provide A Valid ${label || 'input'}.`,
							className: classes.input,
							name: prop,
							maxLength,
							...otherProps,
						},
					}}
					required={required}
					onChange={onInputChange}
				/>
			</div>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flex: 1,
			alignItems: 'center',
			flexWrap: 'wrap',
		},
		textField: {},
		input: {},
		label: {
			flexBasis: '25%',
			justifyContent: 'flex-end',
			display: 'flex',
			paddingRight: '8px',

			[theme.breakpoints.down('sm')]: {
				flexBasis: '100%',
				justifyContent: 'flex-start',
			},
		},
		textWrapper: {
			flexGrow: 1,
			[theme.breakpoints.down('sm')]: {
				flexBasis: '100%',
			},
		},
    requiredField:{
      color:'red'
    }
	})

export default withStyles(styles)(OutcomeTextItem)
